import {Users} from "lucide-react";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";

export default function CharacterEmpty() {
    return (
        <>
            <title>Charaktere | DireDawn</title>
            <DetailPaneState title="Kein Charakter ausgewählt"
                             description="Wähle links einen Charakter aus oder erstelle einen neuen."
                             icon={<Users className="size-10 opacity-50"/>}/>
        </>
    );
}
